import { Component, EventEmitter, Input, Output } from "@angular/core";
import { CommonModule } from "@angular/common";
import { Router } from "@angular/router";
import { DialogModule } from "primeng/dialog";
import { ButtonModule } from "primeng/button";

/**
 * Subscription Upgrade Dialog Component
 *
 * Shows upgrade prompt when user tries to access premium features
 * Matches old QMC buildUpgradeDialog pattern (lines 1584-1596)
 */
@Component({
  selector: "app-subscription-upgrade-dialog",
  standalone: true,
  imports: [CommonModule, DialogModule, ButtonModule],
  templateUrl: "./subscription-upgrade-dialog.component.html",
  styleUrl: "./subscription-upgrade-dialog.component.scss",
})
export class SubscriptionUpgradeDialogComponent {
  @Input() visible = false;
  @Output() visibleChange = new EventEmitter<boolean>();
  @Input() featureName = "Advanced Options";
  @Input() tierName = "your current plan";
  @Input() upgradeUrl = "/my-account/subscription/change-plan";

  constructor(private router: Router) {}

  /**
   * Close the dialog
   */
  onClose(): void {
    this.visible = false;
    this.visibleChange.emit(false);
  }

  /**
   * Navigate to upgrade URL
   * - If URL starts with '/', convert to full URL and open in new tab
   * - If URL starts with 'http', open in new tab directly
   */
  onUpgrade(): void {
    if (!this.upgradeUrl) return;

    if (this.upgradeUrl.startsWith("/")) {
      // Internal route - convert to full URL and open in new tab
      const url = this.router.serializeUrl(
        this.router.createUrlTree([this.upgradeUrl]),
      );
      window.open(url, "_blank", "noopener,noreferrer");
    } else {
      // External URL - open in new tab
      window.open(this.upgradeUrl, "_blank", "noopener,noreferrer");
    }
    this.onClose();
  }
}
